"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_schema_list_1 = require("prosemirror-schema-list");

var Node_1 = __importDefault(require("./Node"));

var CheckboxItem = /*#__PURE__*/function (_Node_1$default) {
  _inherits(CheckboxItem, _Node_1$default);

  var _super = _createSuper(CheckboxItem);

  function CheckboxItem() {
    var _this;

    _classCallCheck(this, CheckboxItem);

    _this = _super.apply(this, arguments);

    _this.handleChange = function (event) {
      var view = _this.editor.view;
      var tr = view.state.tr;

      var _event$target$getBoun = event.target.getBoundingClientRect(),
          top = _event$target$getBoun.top,
          left = _event$target$getBoun.left;

      var result = view.posAtCoords({
        top: top,
        left: left
      });

      if (result) {
        var transaction = tr.setNodeMarkup(result.inside, undefined, {
          checked: event.target.checked
        });
        view.dispatch(transaction);
      }
    };

    return _this;
  }

  _createClass(CheckboxItem, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        Enter: prosemirror_schema_list_1.splitListItem(type),
        Tab: prosemirror_schema_list_1.sinkListItem(type),
        "Shift-Tab": prosemirror_schema_list_1.liftListItem(type),
        "Mod-]": prosemirror_schema_list_1.sinkListItem(type),
        "Mod-[": prosemirror_schema_list_1.liftListItem(type)
      };
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.write(node.attrs.checked ? "[x] " : "[ ] ");
      state.renderContent(node);
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "checkbox_item",
        getAttrs: function getAttrs(tok) {
          return {
            checked: tok.attrGet("checked") ? true : undefined
          };
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "checkbox_item";
    }
  }, {
    key: "schema",
    get: function get() {
      var _this2 = this;

      return {
        attrs: {
          checked: {
            default: false
          }
        },
        content: "paragraph block*",
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: "li[data-type=\"".concat(this.name, "\"]"),
          getAttrs: function getAttrs(dom) {
            return {
              checked: dom.getElementsByTagName("input")[0].checked ? true : false
            };
          }
        }],
        toDOM: function toDOM(node) {
          var input = document.createElement("input");
          input.type = "checkbox";
          input.addEventListener("change", _this2.handleChange);

          if (node.attrs.checked) {
            input.checked = true;
          }

          return ["li", {
            "data-type": _this2.name,
            class: node.attrs.checked ? "checked" : undefined
          }, ["span", {
            contentEditable: false
          }, input], ["div", 0]];
        }
      };
    }
  }]);

  return CheckboxItem;
}(Node_1.default);

exports.default = CheckboxItem;